// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1q44e","closeModal":"styles_closeModal__35bfM","modalContainer":"styles_modalContainer__3mYSV","p":"styles_p__1xdkp","span":"styles_span__1AUuO"};